import { render, staticRenderFns } from "./about_page_configuration.vue?vue&type=template&id=4196a372&"
import script from "./about_page_configuration.vue?vue&type=script&lang=js&"
export * from "./about_page_configuration.vue?vue&type=script&lang=js&"
import style0 from "./about_page_configuration.vue?vue&type=style&index=0&id=4196a372&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports